/* eslint-disable */
import axios from 'axios'

const SERVICEPUBLICAPI = '/Service/public'

// 点赞
function likesCount() {
  const url = `${SERVICEPUBLICAPI}/likes/count?type=XCZX`
  return new Promise(function (resolve, reject) {
    axios.get(url).then(
      m => {
        resolve(m.data)
      }
    ).catch(function (err) {
      reject(err)
    })
  })
}

// 点赞数量
function getLikesCount() {
  const url = `${SERVICEPUBLICAPI}/get/likesCount?type=XCZX`
  return new Promise(function (resolve, reject) {
    axios.get(url).then(
      m => {
        resolve(m.data)
      }
    ).catch(function (err) {
      reject(err)
    })
  })
}

export default {
  likesCount,
  getLikesCount
}


// WEBPACK FOOTER //
// ./src/common/ajax/API/SERVICEPUBLICAPI.js